const ROUTE_VIEW_LOGIN = [
  // 登录注册
  { path: '/login', name: '登录', h5Uri: '/login/login', nativeUri: null, whiteList: true },
  { path: '/register', name: '注册', h5Uri: '/login/register', nativeUri: null, whiteList: true },
  { path: '/agreement1', name: '协议1', h5Uri: '/login/agreement1', nativeUri: null, whiteList: true },
  { path: '/agreement2', name: '协议2', h5Uri: '/login/agreement2', nativeUri: null, whiteList: true },
  { path: '/wechat_authorize', name: '微信授权', h5Uri: '/login/wechat_authorize', nativeUri: null, whiteList: true },
  { path: '/wechat_login', name: '微信登录', h5Uri: '/login/wechat_login', nativeUri: null, whiteList: true }
]

export default ROUTE_VIEW_LOGIN



// WEBPACK FOOTER //
// ./src/router/mapping/login.js